var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1083 8.14815L7.89166 12.3648C7.35 11.8231 7.01666 11.0815 7.01666 10.2565C7.01666 8.60648 8.35 7.27315 10 7.27315C10.825 7.27315 11.5667 7.60648 12.1083 8.14815Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.85 5.06482C13.3917 3.96482 11.725 3.36482 9.99999 3.36482C7.05832 3.36482 4.31666 5.09816 2.40833 8.09816C1.65833 9.27316 1.65833 11.2482 2.40833 12.4232C3.06666 13.4565 3.83332 14.3482 4.66666 15.0648",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01666 16.5315C7.96666 16.9315 8.975 17.1482 10 17.1482C12.9417 17.1482 15.6833 15.4148 17.5917 12.4148C18.3417 11.2398 18.3417 9.26482 17.5917 8.08982C17.3167 7.65649 17.0167 7.24816 16.7083 6.86482",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.925 10.8398C12.7083 12.0148 11.75 12.9731 10.575 13.1898",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89169 12.3648L1.66669 18.5898",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 1.92316L12.1083 8.14816",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.52bfaa0a184298ecbef5b0adad9acc54.svg";
export { ForwardRef as ReactComponent };